import type { IBlacklistPost, IBlacklistPostComment, IBlacklistRule } from '@/types/Data'
import type {
  IGetBlacklistPostComments,
  IGetBlacklistPosts,
  IPayloadBlacklistRule,
  IUpdateBlackList,
} from '@/types/Request'
import BaseService from '../BaseService'

export default class BlacklistServices extends BaseService {
  GetBlacklistPostList(data: IGetBlacklistPosts) {
    return this.POST<IBlacklistPost[]>(this.PATHS.GET_BLACKLIST_POST_LIST, data)
  }

  UpdateBlacklistPost(UpdateBlackList: IUpdateBlackList[]) {
    return this.POST<boolean>(this.PATHS.UPDATE_BLACKLIST_POST, { UpdateBlackList })
  }

  DeleteBlacklistPost(PostIds: string[]) {
    return this.DELETE<boolean>(this.PATHS.DELETE_BLACKLIST_POST, null, { PostIds })
  }

  GetBlacklistCommentList(data: IGetBlacklistPostComments) {
    return this.POST<IBlacklistPostComment[]>(this.PATHS.GET_BLACKLIST_COMMENT_LIST, data)
  }

  DeleteBlacklistComment(PostCommentIds: string[]) {
    return this.DELETE<void>(this.PATHS.DELETE_BLACKLIST_COMMENT, null, { PostCommentIds })
  }

  UpdateBlacklistComment(UpdatePostComments: IUpdateBlackList[]) {
    return this.POST<boolean>(this.PATHS.UPDATE_BLACKLIST_COMMENT, { UpdatePostComments })
  }

  GetBlacklistRuleList() {
    return this.GET<IBlacklistRule[]>(this.PATHS.GET_BLACKLIST_RULE_LIST)
  }

  CreateBlacklistRule(data: IPayloadBlacklistRule) {
    return this.POST<boolean>(this.PATHS.CREATE_BLACKLIST_RULE, data)
  }

  UpdateBlacklistRule(data: IPayloadBlacklistRule) {
    return this.PUT<boolean>(this.PATHS.UPDATE_BLACKLIST_RULE, data)
  }

  DeleteBlacklistRule(BlackListId: string) {
    return this.DELETE<boolean>(this.PATHS.DELETE_BLACKLIST_RULE, null, { BlackListId })
  }
}
